import { render, staticRenderFns } from "./ClassSlots.vue?vue&type=template&id=91399636"
import script from "./ClassSlots.vue?vue&type=script&lang=js"
export * from "./ClassSlots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports